import styled from '@emotion/styled';

export const ExportToCsvButton = styled('button', { label: 'ExportToCsvButton' })<{isDisabled: boolean}>`
    align-items: center;
    background-color: #bbb;
    border: none;
    color: #fff;
    cursor: ${(props): string => props.isDisabled ? 'not-allowed' : 'pointer'};
    display: flex;
    font-size: 14px;
    margin-left: auto;
    padding: 0 6px 0 0;
`;
